import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { liveUsageMgmtAccountIdsSelector } from "@/store/live-usage-mgmt/selectors/store-selectors/liveUsageMgmtAccountIdsSelector";
import { cloudChiprApi } from "@/services/cloudchipr.api";

export const getLiveUsageResourcesTypeStatusesFixedCacheKey = (
  accountIds?: string[] | null,
) =>
  `postOrganisationsCurrentAccountsResourceTypesStatuses-fixed-cache-key-${accountIds?.join(",")}`;

export const getLiveUsageResourcesTypeStatusesThunk = createAsyncThunk(
  "liveUsageMgmt/getLiveUsageResourcesTypeStatuses",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;
    const accountIds = liveUsageMgmtAccountIdsSelector(state);

    if (!accountIds) {
      return;
    }

    const { postOrganisationsCurrentAccountsResourceTypesStatuses } =
      cloudChiprApi.endpoints;

    return await dispatch(
      postOrganisationsCurrentAccountsResourceTypesStatuses.initiate(
        { body: { account_ids: accountIds } },
        {
          fixedCacheKey:
            getLiveUsageResourcesTypeStatusesFixedCacheKey(accountIds),
        },
      ),
    ).unwrap();
  },
);
